<template>
  <b-container class>
    <b-row align-h="start">
      <h1>Convert SNA to Sinclair BASIC</h1>
    </b-row>
    <b-row>
      <h2>Here paste the .SNA file</h2>
    </b-row>
    <b-row>
      <b-form-textarea
        id="textarea1"
        v-model="text"
        placeholder="Here paste the .SNA file"
        :rows="3"
        :max-rows="6"
      ></b-form-textarea>
    </b-row>
        <b-row>
      <h5>Show true numbers: </h5>
      <b-form-radio-group id="radios1"
          v-model="mode"
        :options="options"></b-form-radio-group>
    </b-row>
    <b-row>
      <h2>Here is the BASIC program, found in the SNA</h2>
    </b-row>
    <b-row>
      <div class="sourceout" v-html="textout"></div>
      <b-form-textarea id="textarea2" readonly v-model="textout" :rows="10" :max-rows="15"></b-form-textarea>
    </b-row>
    <b-row>
      <div id="textareax"></div>
    </b-row>
  </b-container>
</template>

<script>
var doDrag = function(_this) {
  var holder = document.getElementById("textarea1");

  holder.ondragover = function() {
    this.className = "form-control";
    return false;
  };
  holder.onmouseleave = function() {
    this.className = "form-control";
    return false;
  };
  holder.ondrop = function(e) {
    this.className = "form-control";
    e.preventDefault();

    var file = e.dataTransfer.files[0];
    var reader = new FileReader();
    reader.onload = function(event) {
      _this.binary = new Uint8Array(event.target.result);
      _this.text =
        "Name: " +
        file.name +
        "\nFile size: " +
        file.size +
        "\nFile type: " +
        file.type;
    };
    reader.readAsArrayBuffer(file);

    return false;
  };
};

var peek = (arr, addr) => {
  // if (!this.binary) return null;
  var internal = addr - 16384 + 27;
  if (!arr || (arr.length < internal)) return null;
  return arr[internal]
}

var dpeek = (arr, addr) => {
  // if (!this.binary) return null;
  var internal = addr - 16384 + 27;
  if (!arr || (arr.length < internal)) return null;
  return arr[internal] + 256 * arr[internal + 1]
}
var drpeek = (arr, addr) => {
  // if (!this.binary) return null;
  var internal = addr - 16384 + 27;
  if (!arr || (arr.length < internal)) return null;
  return arr[internal] * 256 + arr[internal + 1]
}

const tokens = [
  " ", "▝", "▘", "▀", "▗", "▐", "▚", "▜", // 80
  "▖", "▞", "▌", "▛", "▄", "▟", "▙", "█", // 88
  "Ⓐ", "Ⓑ", "Ⓒ", "Ⓓ", "Ⓔ", "Ⓕ", "Ⓖ", "Ⓗ", // 90
  "Ⓘ", "Ⓙ", "Ⓚ", "Ⓛ", "Ⓜ", "Ⓝ", "Ⓞ", "Ⓟ", // 98
  "Ⓠ", "Ⓡ", "Ⓢ", "Ⓣ", "Ⓤ", "RND", "INKEY$", "PI", // A0
  "FN", "POINT", "SCREEN$", "ATTR", "AT", "TAB", "VAL$", "CODE", // A8
  "VAL", "LEN", "SIN", "COS", "TAN", "ASN", "ACS", "ATN", // B0
  "LN", "EXP", "INT", "SQR", "SGN", "ABS", "PEEK", "IN", // B8
  "USR", "STR$", "CHR$", "NOT", "BIN", "OR", "AND", "<=", // C0
  ">=", "<>", "LINE", " THEN", " TO", " STEP", "DEF FN", "CAT", // C8
  "FORMAT", "MOVE", "ERASE", "OPEN #", "CLOSE #", "MERGE", "VERIFY", "BEEP", // D0
  "CIRCLE", "INK", "PAPER", "FLASH", "BRIGHT", "INVERSE", "OVER", "OUT", // D8
  "LPRINT", "LLIST", "STOP", "READ", "DATA", "RESTORE", "NEW", "BORDER", // E0
  "CONTINUE", "DIM", "REM", "FOR", "GO TO", "GO SUB", "INPUT", "LOAD", // E8
  "LIST", "LET", "PAUSE", "NEXT", "POKE", "PRINT", "PLOT", "RUN", // F0
  "SAVE", "RANDOMIZE", "IF", "CLS", "DRAW", "CLEAR", "RETURN", "COPY" // F8
]

// "Ⓐ", "Ⓑ", "Ⓒ", "Ⓓ", "Ⓔ", "Ⓕ", "Ⓖ", "Ⓗ", "Ⓘ", "Ⓙ", "Ⓚ", "Ⓛ", "Ⓜ", "Ⓝ", "Ⓞ", "Ⓟ", "Ⓠ", "Ⓡ", "Ⓢ", "Ⓣ", "Ⓤ"

export default {
  name: "sna2bas",
  components: {},
  data() {
    return {
      text: "",
      binary: [],
      mode: 'yes',
      options: [
        { text: 'YES', value: 'yes' },
        { text: 'NO', value: 'no' }
      ]
    };
  },
  computed: {
    textout: {
      get() {
        if (!(this.binary && this.binary.length)) { return "NULL" }
        // var out = "";
        var prog = dpeek(this.binary, 23635);
        var vars = dpeek(this.binary, 23627);

        var ln = [];

        let mode = this.mode

        for (var ptr = prog; ptr < vars;) {
          var lnum = drpeek(this.binary, ptr).toString(10);
          ptr += 2;
          var llen = dpeek(this.binary, ptr);
          ptr += 2;

          var line = "";
          var pos = 0;
          for (var i = 0; i < llen - 1; i++) {
            var char = peek(this.binary, ptr + i)
            if (char === 6) {
              if (pos < 15) {
                while (pos < 15) {
                  line += " ";
                  pos++
                }
              } else {
                pos = 0;
                line += "<br>"
              }
              continue
            }
            if (char === 13) { line += "<br>"; pos = 0; continue }
            if (char === 14) {
              // number
              console.log(peek(this.binary, ptr + i + 1), peek(this.binary, ptr + i + 2), peek(this.binary, ptr + i + 3), peek(this.binary, ptr + i + 4), peek(this.binary, ptr + i + 5))
              if (peek(this.binary, ptr + i + 1) === 0 && mode === "yes") {
                var int = peek(this.binary, ptr + i + 3) + 256 * peek(this.binary, ptr + i + 4)
                if (peek(this.binary, ptr + i + 2) === 255) { int *= -1 }
                line += "<small>" + int + "</small>"
              }
              i += 5
              continue
            }
            if (char < 32) {
              continue
            }
            if (char < 128) {
              line += String.fromCharCode(char)
              pos++
            } else {
              line += "<b>" + tokens[char - 128]
              pos += tokens[char - 128].length
              if (char > 164) { line += " "; pos++ }
              line += "</b>"
            }
            if (pos >= 32) {
              pos = 0;
              line += "<br>"
            }
          }

          while (lnum.length < 4) { lnum = " " + lnum }

          ln.push(lnum + " " + line)
          ptr += llen
        }

        //window.$("#textareax").html(ln.join("<br>"))

        return ln.join("\n");
      },
      set() {
        return;
      }
    }
  },
  mounted() {
    doDrag(this);
  }
};
</script>

<style>
@import url(//db.onlinewebfonts.com/c/e3d24132ac33e0d50a05f0f98f3977ef?family=ZX+Spectrum-7);
@font-face {font-family: "ZX Spectrum-7"; src: url("//db.onlinewebfonts.com/t/e3d24132ac33e0d50a05f0f98f3977ef.eot"); src: url("//db.onlinewebfonts.com/t/e3d24132ac33e0d50a05f0f98f3977ef.eot?#iefix") format("embedded-opentype"), url("//db.onlinewebfonts.com/t/e3d24132ac33e0d50a05f0f98f3977ef.woff2") format("woff2"), url("//db.onlinewebfonts.com/t/e3d24132ac33e0d50a05f0f98f3977ef.woff") format("woff"), url("//db.onlinewebfonts.com/t/e3d24132ac33e0d50a05f0f98f3977ef.ttf") format("truetype"), url("//db.onlinewebfonts.com/t/e3d24132ac33e0d50a05f0f98f3977ef.svg#ZX Spectrum-7") format("svg"); }
textarea {
  font-family: monospace !important;
}

#textarea2 {display:none}

#textareax {
  background-color:#eee;
  white-space: pre;
  width:100%;
  overflow-x:scroll;
  word-wrap: break-word;
  font-family: "Lucida Console", Monaco, monospace !important;
  font-size:25px;
  line-height: 28px;
  /*
  font-family: "ZX Spectrum-7"*/
}

#textareax small {
  font-size:12px;
  border:1px solid #ddd;
  background-color:#ddd;
  padding:1px
}
</style>
